import { useEffect, useState } from "react";
import { MdTimer } from "react-icons/md";
import moment from "moment";
import AutolineNote from "../../components/shared/AutolineNote";
import { Button, Checkbox, DatePicker, Form } from "antd";
import { useForm } from "antd/lib/form/Form";

import { RiFilterOffLine } from "react-icons/ri";
import { BsCalendarCheck, BsChevronRight, BsWallet2 } from "react-icons/bs";
import formatShort from "../../utils/formatShort";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { REACT_APP_ARPS_BASE_URL } from "../../utils/urls";

const { RangePicker } = DatePicker;

export default function Summaries() {
  
  const [ loading , setLoading ] = useState({
    parts: false,
    open: false,
    invoiced: false,
    completed: false,
    authorization: false,
    labor: false,
    inprogress: false,
    estimate: false
  })

  const [ open, setOpen ] = useState([])
  const [ completed, setCompleted ] = useState([])
  const [ invoiced, setInvoiced ] = useState([])
  const [ estimate, setEstimate ] = useState([])
  const [ inprogress, setInProgress ] = useState([])

  const [ waitingPart, setWaitingParts ] = useState([]);
  const [ waitingAuthorization, setWaitingAuthorization ] = useState([])
  const [ waitingLabor, setWaitingLabor ] = useState([])

  const start = moment().startOf("isoWeek").format("YYYYMMDD");
  const end = moment().endOf("isoWeek").format("YYYYMMDD");
  const [startDate, setStateDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [selected, setSelected] = useState({ id: 1, name: "Weekly" });

  const [showRange, setShowRange] = useState(false);
   
  const [ form ] = useForm()


  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
  };

  const onSelectPeriod = (period: any) => {
    if (period?.name === "Weekly") {
      const start = moment().startOf("isoWeek").format("YYYYMMDD");
      const end = moment().endOf("isoWeek").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
    if (period?.name === "Monthly") {
      const start = moment().startOf("year").format("YYYYMMDD");
      const end = moment().endOf("year").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
    if (period?.name === "Yearly") {
      const start = moment().startOf("year").format("YYYYMMDD");
      const end = moment().endOf("year").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
  };


  const clearDate = () => {
    const period = { id: 1, name: "Weekly" };
    form.resetFields();
    const start = moment().startOf("isoWeek").format("YYYYMMDD");
    const end = moment().endOf("isoWeek").format("YYYYMMDD");
    setStateDate(start);
    setEndDate(end);
    // setSelected(period);
  };

  const periods = [
    { id: 1, name: "Weekly" },
    { id: 2, name: "Monthly" },
    { id: 3, name: "Yearly" },
  ];


  /*************** RETRIEVING DATA FROM THE API ************/

  const fetchOpen = async ( date: any = startDate) => {

    const load_flag = loading
    load_flag.open = true
    setLoading(load_flag);

    const response = await fetch(
      // `${REACT_APP_ARPS_BASE_URL}/wip/open?start=${startDate}&end=${endDate}`
      `${REACT_APP_ARPS_BASE_URL}/wip/open`
    );
    const data = await response.json();
    
    // const res = await getServiceHistory(data);
    // setOpen(data);
    
    load_flag.open = false
    setLoading(load_flag);
  }

  /*********************** END *****************************/


  useEffect(() => {
    fetchOpen()
  }, [startDate]);


  return (
    <div className="flex flex-col justify-center items-center mt-8">
      <AutolineNote />
      <div className="flex justify-between items-center border-b  border-gray-300 py-2 mx-4">
        <div className="flex">
          <Form layout="inline" form={form}>
            {showRange ? (
              <div className="flex justify-center items-center">
                <Form.Item name="ranger">
                  <RangePicker
                    allowClear={true}
                    onChange={onRangeChange}
                    format={"DD-MM-YYYY"}
                  />
                </Form.Item>

                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <Form.Item name="picker">
                  <DatePicker
                    onChange={onDateChange}
                    format={"DD-MM-YYYY"}
                    placeholder="Specific date"
                  />
                </Form.Item>
                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            )}
            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>
        </div>
        <div className="">
          <div className="flex flex-row">
            {periods.map((period: any, index: number) => (
              <button
                className={`flex justify-center items-center border border-gray-300 py-2 px-4 ml-2 ${
                  selected.id === period.id ? `bg-red-100` : ``
                }`}
                key={index}
                onClick={() => {
                  setSelected(period);
                  onSelectPeriod(period);
                }}
              >
                <span>
                  <BsCalendarCheck />
                </span>
                <span className="ml-2">{period.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>


      <div className="grid grid-cols-12 gap-x-3 my-2 mx-4">
        <div className="col-span-12 sm:col-span-9 md:col-span-9">
          <div className="grid grid-cols-12 gap-x-3 justify-center">
            <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">OPEN</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { open.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">5 %</span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">INVOICED</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { invoiced.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">2 %</span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">ESTIMATE</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { estimate.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretDown color="red" />
                    <span className="text-red-600">5 %</span>
                  </div> */}
                </div>
              </div>
            </div>
            
            {/* <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">COMPLETED</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { completed.length }
                  </div>
                  
                </div>
              </div>
            </div> */}

            <div className="col-span-12 sm:col-span-3 md:col-span-3 mt-2">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">INPROGRESS</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { inprogress.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">3 %</span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-12 md:col-span-9 mt-2">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">COMPLETED BUT NOT INVOICED</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { completed.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">3 %</span>
                  </div> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


                
      <div className="grid grid-cols-12 gap-x-3 my-2 mx-4">
        <div className="col-span-12 sm:col-span-9 md:col-span-9">
          <div className="grid grid-cols-12 gap-x-3">
            <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">PARTS</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { waitingPart.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">5 %</span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">AUTHORIZATION</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { waitingAuthorization.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">2 %</span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">APPROVAL</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { waitingAuthorization.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretDown color="red" />
                    <span className="text-red-600">5 %</span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">LABOR</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    { waitingLabor.length }
                  </div>
                  {/* <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">3 %</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}
